<template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">Repair List</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      :list-options="list_options"
      @reset_table="reset_table"
      @options_changed="update_table($event)"
      @filter_changed="update_filter($event)"
      :schema="schema"
      :query-select-options="options"
      :new-to="{ name: 'service_repair.create', params: { id: 0 } }"
      new-button-text="New Repair"
    >
      <template slot="middle">
        <!-- <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        /> -->
      </template>
    </o-list-toolbar>
    <!-- @row-selected="onRowSelected"
      :selectable="selected.selectable" :key="selected.selectable" -->
    <b-table
      striped
      bordered
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list"
      thead-class="o-gradient-header position-sticky"
      sticky-header="70vh"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
      :tbody-tr-class="rowClass"
    >
      <template v-slot:head(checked)="data">
        <input v-model="toogleAll" @click="toogleAllSelected" type="checkbox" />
      </template>
      <!-- <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template> -->
      <template slot="cell(active_end_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_end_date'"
        >
          <date-display
            :value="item.active_end_date"
            :default-end-date="item.active_end_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_start_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_start_date'"
        >
          <date-display
            :value="item.active_start_date"
            :default-end-date="item.active_end_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(amount)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount'"
        >
          $
          <number-display
            :decimals="2"
            :value="item.amount"
            :default-end-date="item.active_end_date"
          />
        </o-link-cell>
      </template>
      <template slot="cell(amount_adjustment)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount_adjustment'"
        >
          <number-display
            :value="item.amount_adjustment"
            :decimals="2"
            :default-end-date="item.active_end_date"
          />
        </o-link-cell>
      </template>
      <template slot="cell(bill_to)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'bill_to'"
        >
          <lookup-display
            :default-end-date="item.active_end_date"
            :list="optionCrewItemsById"
            :value="item.bill_to"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template #cell(bill_to_supplier)="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'bill_to_supplier'"
        >
          <lookup-display
            :list="optionSupplierItemsById"
            :value="item.bill_to_supplier"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(bill_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'bill_no'"
        >
          <s v-if="item.active_end_date" class="text-red">
            <p v-for="bill in item.bills">{{ bill.bill_number }}</p>
            <p v-if="item.bills.length <= 0">None</p>
          </s>

          <span v-else>
            <p v-for="bill in item.bills">{{ bill.bill_number }}</p>
            <p v-if="item.bills.length <= 0">None</p>
          </span>
        </o-link-cell>
      </template>
      <template slot="cell(bill_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'bill_date'"
        >
          <s v-if="item.active_end_date" class="text-red">
            <p v-for="bill in item.bills">{{ bill.date_billed }}</p>
            <p v-if="item.bills.length <= 0">None</p>
          </s>

          <span v-else>
            <p v-for="bill in item.bills">{{ bill.date_billed }}</p>
            <p v-if="item.bills.length <= 0">None</p>
          </span>
        </o-link-cell>
      </template>
      <template slot="cell(builder)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'builder'"
        >
          <lookup-display
            :default-end-date="item.active_end_date"
            :list="optionCustomerItemsById"
            :value="item.builder"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(cancelled_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'cancelled_date'"
        >
          <date-display
            :default-end-date="item.active_end_date"
            :value="item.cancelled_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(charge_subcontractor)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'charge_subcontractor'"
        >
          <boolean-display
            :default-end-date="item.active_end_date"
            :value="item.charge_subcontractor"
            false-text=""
          ></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(checked)" slot-scope="{ index, item }">
        <input
          v-model="item.checked"
          @click="toggleChecked(item)"
          type="checkbox"
        />

        <!-- remove this for testing -->
        <!-- <o-checkbox
          @input="toggleChecked(item)"
          v-model="item.checked"
          name="checked"
          nolabel
        ></o-checkbox> -->
        <!-- <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'checked'"
        >
          <boolean-display :value="item.checked"></boolean-display>
        </o-link-cell> -->
      </template>
      <template slot="cell(code)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'code'"
        >
          <s v-if="item.active_end_date" class="strike-through">
            <default-display
              :value="item.code"
              :default-end-date="item.active_end_date"
            ></default-display>
          </s>
          <default-display
            v-else
            :value="item.code"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(audit_trail)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{
            name: 'service_repair.history',
            params: { repairId: item.id, code: item.code },
          }"
        >
          <s v-if="item.active_end_date" class="strike-through">
            <default-display
              value="View"
              :default-end-date="item.active_end_date"
            >
            </default-display>
          </s>
          <default-display
            v-else
            value="View"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(comments)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'comments'"
        >
          <a
            v-if="item.id !== editCommentsID"
            class="editable"
            @click="editComments(item)"
          >
            <default-display
              v-if="item.comments"
              :value="item.comments"
              default-value="[Set]"
            ></default-display>
            <div v-if="!item.comments" class="text-red">[Set]</div>
          </a>
          <div v-if="item.id === editCommentsID">
            <b-textarea
              v-model="newComments"
              :rows="5"
              style="width: 150px"
              @input="changedComments(item.id)"
            ></b-textarea>
            <b-button
              :disabled="!editCommentsChanged"
              variant="success"
              @click="saveComments(item)"
              >Save
            </b-button>
            <b-button variant="info" @click="undoComments(item)"
              >cancel
            </b-button>
          </div>
        </o-link-cell>
      </template>
      <template slot="cell(completed_by)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'completed_by'"
        >
          <lookup-display
            :default-end-date="item.active_end_date"
            :list="optionSupplierItemsById"
            :value="item.completed_by"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(completed_by_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'completed_by_name'"
        >
          <default-display
            :value="item.completed_by_name"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(completed_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'completed_date'"
        >
          <date-display
            :default-end-date="item.active_end_date"
            :value="item.completed_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :default-end-date="item.active_end_date"
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template #cell(crew_supplier)="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'crew_supplier'"
        >
          <lookup-display
            :default-end-date="item.active_end_date"
            :list="optionCrewItemsById"
            :value="item.crew_supplier"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_received)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_received'"
        >
          <date-display
            :default-end-date="item.active_end_date"
            :value="item.date_received"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(description)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'description'"
        >
          <default-display
            :value="item.description"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(invoices)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'invoices'"
        >
          <default-display
            :value="item.invoices"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(job)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'job'"
        >
          <default-display
            :value="item.job"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(labour_hour_rate)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'labour_hour_rate'"
        >
          <number-display
            :value="item.labour_hour_rate"
            :decimals="2"
            :default-end-date="item.active_end_date"
          />
        </o-link-cell>
      </template>
      <template slot="cell(labour_hours)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'labour_hours'"
        >
          <number-display
            :value="item.labour_hours"
            :decimals="2"
            :default-end-date="item.active_end_date"
          />
        </o-link-cell>
      </template>
      <template slot="cell(labour_total_cost)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'labour_total_cost'"
        >
          <number-display
            :value="item.labour_total_cost"
            :decimals="2"
            :default-end-date="item.active_end_date"
          />
        </o-link-cell>
      </template>
      <template slot="cell(materials_sub_total)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'materials_sub_total'"
        >
          <number-display
            :value="item.materials_sub_total"
            :decimals="2"
            :default-end-date="item.active_end_date"
          />
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :default-end-date="item.active_end_date"
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(old_job_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'old_job_no'"
        >
          <default-display
            :value="item.old_job_no"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(purchase_order_number)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'purchase_order_number'"
        >
          <default-display
            :value="item.purchase_order_number"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(repair_completed_email)"
        slot-scope="{ index, item }"
      >
        <input
          v-model="item.repair_completed_email"
          @click="toggleRepairCompleteEmail(item)"
          type="checkbox"
        />
        <!-- <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_completed_email'"
        >
          <boolean-display
            :value="item.repair_completed_email"
          ></boolean-display>
        </o-link-cell> -->
      </template>
      <template slot="cell(repair_files)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_files'"
        >
          <default-display
            :value="item.repair_files"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(repair_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_notes'"
        >
          <default-display
            :value="item.repair_notes"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(repair_types)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_types'"
        >
          <default-display
            :value="item.repair_types"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_address)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_address'"
        >
          <default-display
            :value="item.site_address"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(suburb)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'suburb'"
        >
          <default-display
            :value="item.suburb"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor'"
        >
          <lookup-display
            :default-end-date="item.active_end_date"
            :list="optionSupervisorItemsById"
            :value="item.supervisor"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor_name'"
        >
          <default-display
            :value="item.supervisor_name"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(total_materials_cost)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'total_materials_cost'"
        >
          <number-display
            :value="item.total_materials_cost"
            :decimals="2"
            :default-end-date="item.active_end_date"
          />
        </o-link-cell>
      </template>
      <template slot="cell(used_materials)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'used_materials'"
        >
          <default-display
            :value="item.used_materials"
            :default-end-date="item.active_end_date"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(want_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_repair.edit', params: { id: item.id } }"
          :when="first_column_key === 'want_date'"
        >
          <date-display
            :default-end-date="item.active_end_date"
            :value="item.want_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'service_repair.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import { mapActions } from "vuex";
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";
import moment from "moment";
import CrewSupplierMixin from "@/mixins/CrewSupplierMixin";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("ServiceRepair", "service_repair"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("ServiceRepair"),
    CreateCodeTableFetchMixin(["Supervisor", "Customer", "Supplier"]),
    CrewSupplierMixin(),
  ],
  data: function () {
    return {
      toogleAll: false,
      schemaModel: cleanUpModel(
        schema.ServiceRepair,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.ServiceRepair),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Cancelled",
          code: "cancelled",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Completed but not Billed",
          code: "completed_but_not_billed_subbie",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Adjustment To Bill",
          code: "adjustment_to_bill",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Adjustment To Bill (As per WI7)",
          code: "adjustment_to_bill_spec",
          options: { offset: 0, sort: "id" },
        },
        { name: "Billed", code: "billed", options: { offset: 0, sort: "id" } },
        {
          name: "Completed",
          code: "completed",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Deleted",
          code: "inactive",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Rejected Repairs",
          code: "rejected_repairs",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Completed Repairs",
          code: "completed_repairs",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Accepted Repairs",
          code: "accepted_repairs",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "New Repair Request",
          code: "new_repair_request",
          options: { offset: 0, sort: "id" },
        },
      ],

      newComments: "",
      editCommentsID: null,
      editCommentsChanged: false,

      user_column_selection: null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
        supervisor_name: { label: "Contact Person" },
        code: { label: "Repair Ref No" },
        job: { label: "Job No." },
        crew: { label: "Subcontractor" },
        charge_subcontractor: { label: "Charge" },
        amount: { tdClass: "text-right" },
        comments: { tdClass: "adjustWidth", thClass: "adjustWidth" },
      },
    };
  },
  methods: {
    ...mapActions("ServiceRepairModule", ["patchItem"]),
    updateChange(payload) {
      this.patchItem(payload);
    },
    updateChecked(item, checked) {
      let payload = { id: item.id, checked: checked };
      this.updateChange(payload);
    },
    toggleChecked(item) {
      this.updateChecked(item, !item.checked);
    },
    toogleAllSelected() {
      this.items.forEach((element) => {
        this.updateChecked(element, !this.toogleAll);
        return;
      });
    },
    toggleRepairCompleteEmail(item) {
      let payload = {
        id: item.id,
        repair_completed_email: !item.repair_completed_email,
      };
      this.updateChange(payload);
    },

    rowClass(item, type) {
      if (item && type === "row") {
        let cssRow = "";

        // get the complete date + 3 days
        // get the current date
        // if complete_date and current_date_3 is equal and completion_accept_date is null then make the row red
        // and this process will only applicable in repair request and workflow_instance is not null

        if (item.workflow_instance && item.accept_date) {
          const dateplus3 = moment(new Date(item.accept_date))
            .add(3, "days")
            .format("YYYY-MM-DD");
          const today = moment(new Date()).format("YYYY-MM-DD");
          console.log("dateplus3", dateplus3);
          console.log("today", today);
          // console.log("is overdue", dateplus3 === today);
          if (dateplus3 <= today && !item.completed_date) {
            return (cssRow = "table-red ");
          }
        }

        if (item.checked) {
          cssRow += "table-green ";
        }
        if (item.active_end_date) {
          cssRow += "strike-through ";
        }
        return cssRow;
      }
    },
    editComments(item) {
      this.newComments = item.comments;
      this.editCommentsID = item.id;
      this.editCommentsChanged = false;
    },
    changedComments(itemID) {
      this.editCommentsChanged = true;
    },
    saveComments(item) {
      var payload = { id: item.id, comments: this.newComments };
      item.comments = this.newComments; // assume it saves
      this.patchItem(payload);
      this.undoComments(item); // clear the text box
    },
    undoComments(item) {
      this.newComments = "";
      this.editCommentsID = null;
      this.editCommentsChanged = false;
    },
  },
  computed: {
    options() {
      return {
        Job: {
          options: this.optionJobItems,
          textField: "description",
          valueField: "id",
        },
        Supervisor: {
          options: this.optionSupervisorItems,
          textField: "name",
          valueField: "id",
        },
        Customer: {
          options: this.optionCustomerItems,
          textField: "name",
          valueField: "id",
        },
        Supplier: {
          options: this.optionSupplierItems,
          textField: "name",
          valueField: "id",
        },
        Crew: {
          options: this.optionCrewItems,
          textField: "name",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "checked",
        "code",
        "job__id",
        "date_received",
        "builder__name",
        "job__crew_supplier__name",
        "charge_subcontractor",
        "site_address",
        "suburb",
        "description",
        "comments",
        "want_date",
        "bill_to_supplier",
        "completed_date",
        "completed_by",
        "repair_completed_email",
        "amount",
        "bill_no",
        "bill_date",
        "supervisor_name",
        "audit_trail",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[1].key;
      } else {
        return null;
      }
    },
  },
};
</script>
<style>
.text-red {
  color: red;
}
.strike-through {
  text-decoration: line-through;
  color: red;
}
.table-green {
  background-color: #92c836 !important;
}
.table-red {
  background-color: red !important;
  color: white !important;
}
.b-table-sticky-header > .table.b-table > thead > tr > th {
  position: sticky !important;
}
.adjustWidth {
  width: 40px;
}

a.editable {
  text-decoration: none;
  border-bottom: dashed 1px #428bca;
  color: black;
  font-weight: bold;
}
</style>
